import { Disclosure } from "@headlessui/react"
import Accordion from "../Accordion/Accordion";
import FaChevronDown from "../SVG/Fontawesome/FaChevronDown";
import FaPlusMinus from "../SVG/Fontawesome/FaPlusMinus";

const FAQ = (props: {
  data?: {
    question: string;
    answer: string[];
  }[];
  className?: string;
}) => {
  if (!props.data?.length) return null;

  return (
    <section>
      <h2>
        Frequently Asked Questions
      </h2>
      <div className="flex flex-col">
        {props.data.map((x, i) => (
          <div className="w-full" key={i.toString()}>
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between items-center border-t-2 text-left py-6">
                    <span className="font-semibold">{x.question}</span>
                    <FaPlusMinus className="w-7 h-7" isOpen={!open} />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pb-4 text-sm text-badge">
                    {x.answer.map((y, j) => (
                      <div key={j.toString()} className="my-1 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: y }}></div>
                    ))}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>))}
      </div>
    </section>
  );
}

export default FAQ;